module.exports = __webpack_public_path__ + "img/info_btn.aa67a81c.png";